var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubDivisionListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4218_13038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40353 20.707V1.95703",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65353 16.957L6.40353 20.707L10.1535 16.957",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73669 6.125H18.4867",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73669 2.79199H19.7367",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73669 9.45898H16.4034",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73669 12.792H14.7367",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4218_13038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.361694 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubDivisionListIcon);
export default __webpack_public_path__ + "static/media/sub-division-list-icon.d80462b6fc7a17be1738d7d3e6d3f911.svg";
export { ForwardRef as ReactComponent };